import { formatLocalhostUrl, formatEventDateTime, formatDateTimeSlot, removeLangFromUrl } from "./functions";

const themeLayout = () => {
  $(() => {
    $(document.body).on("updated_cart_totals", () => {
      // code to reload page here
      formatEventDateTime(document.querySelectorAll("dd.variation-Slot"));
    });

    // Carrello e Account - Formatta info carrello e riepilogo ordini
    if (document.querySelector(".woocommerce-table") || document.querySelector(".shop_table")) {
      formatEventDateTime(document.querySelectorAll("dd.variation-Slot"));
    }

    // Pagamento - Formatta Data
    if (document.getElementById("order-detail-section")) {
      let paymentDate = document.querySelectorAll("#order-detail-section div .event-slot-date");
      paymentDate.forEach((dateSlot) => {
        let formattedDate = formatDateTimeSlot(dateSlot.dataset.slotDate),
          dateSpan = dateSlot.querySelector("span");
        dateSpan.innerHTML = formattedDate;
      });
    }

    // Order Recieved
    if (document.querySelectorAll(".woocommerce-table__product-name.product-name .order_item_meta_values span b")) {
      let spanB = document.querySelectorAll(".woocommerce-table__product-name.product-name .order_item_meta_values span"),
        baseUrl = formatLocalhostUrl() + "/wp-content/themes/biglietteria-theme-2024/assets/img/";

      if (spanB.length > 0) {
        spanB.forEach(function (bValue) {
          let logo = bValue.querySelector("b");
          switch (logo.innerHTML) {
            case "Ticket: ":
              logo.style.backgroundImage = "url(" + baseUrl + "icon-ticket.svg" + ")";
              break;
            case "Slot: ":
              let slot = bValue.innerHTML.split("</b>"),
                dateTime = slot[1].split(" "),
                format = "";

              if (dateTime == "open-ticket\t\t") {
                format += '<div class="order-recieved-service"><span class="date-logo"></span>Biglietto Open</div>';
              } else {
                if (dateTime[0].split("-").length === 3 && dateTime[1].split(":").length === 3) {
                  format += '<div class="order-recieved-service"><span class="date-logo"></span>' + formatDateTimeSlot(dateTime[0]) + "</div>";
                  format += '<div class="order-recieved-service"><span class="time-logo"></span>' + dateTime[1] + "</div>";
                }
              }
              bValue.innerHTML = format;
              break;
            default:
              Object.assign(logo.style, {
                display: "flex",
                alignItems: "center",
                fontWeight: "300",
                color: "var(--text-color-1)",
                width: "auto",
              });
              let serviceLogo = document.createElement("span");
              serviceLogo.classList.add("service-logo");
              logo.prepend(serviceLogo);
              bValue.classList.add("d-flex", "align-items-center");
          }
        });
      }
    }

    // Close User Login Modal Btn
    if (document.getElementById("close-login-modal-btn")) {
      document.getElementById("close-login-modal-btn").addEventListener("click", function () {
        document.getElementById("loginModal").classList.remove("show");
        Object.assign(document.getElementById("loginModal").style, {
          display: "none",
          height: "0",
        });
      });
    }

    // Search Btn
    document.getElementById("submit_search").addEventListener("click", function (e) {
      e.preventDefault();
      let searchInputValue = document.getElementById("search-input").value,
        url = formatLocalhostUrl() + "/?s=" + searchInputValue;
      window.location.href = url;
    });
  });
};

export default themeLayout;

